module.exports = __webpack_public_path__ + "media/Beneath Your Beautiful -Dr Sid Ft Tiwa Savage.936c7636.mp3";